/**
 * @file alert in vue version
 */

import  { messageBox } from '@/ui';

export default (options: {
  title: string;
  msg: string;
  confirmText: string;
  showConfirmButton: boolean | undefined;
  confirm: () => void;
}) => {
  if (typeof options === 'string') {
    messageBox.alert(options);
    return;
  }

  const { title, msg: message, confirmText: confirmButtonText, showConfirmButton = false } = options;

  const boxOptions: Record<string, any> = {
    title,
    message,
    confirmButtonText,
    showConfirmButton,
  };

  return messageBox(boxOptions).then(() => {
    options.confirm();
  });
};
